import type { OnboardingRouter } from "replo-publisher/src/trpc/routers/onboarding";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: onboardingRouter,
  client: onboardingClient,
  utils: onboardingUtils,
  options: onboardingOptions,
} = createTrpcRouterConfig<OnboardingRouter>({
  path: "onboarding",
  queryClient: getNamespacedQueryClient("onboarding"),
});

export {
  onboardingClient,
  onboardingRouter,
  onboardingUtils,
  onboardingOptions,
};
